import Vue from 'vue'
import Vuei18n from 'vue-i18n'

Vue.use(Vuei18n)

import fr_ui from './fr/ui.json'
// import fr_countries from './fr/countries.json'
// import fr_authPages from './fr/auth-pages.json'
// import fr_onboarding from './fr/onboarding.json'
// import fr_organisation from './fr/service-organisation.json'
// import fr_settings from './fr/service-settings.json'
// import fr_odoo_timesheet from './fr/service-odoo-timesheet.json'

const defaultLocale = 'fr'

const languages = {
	fr : {
		'ui' : fr_ui
		// 'utils' : fr_utils,
		// 'countries' : fr_countries,
		// 'auth' : fr_authPages,
		// 'onboarding' : fr_onboarding,
		// 'organisation' : fr_organisation,
		// 'settings' : fr_settings,
		// 'odootm' : fr_odoo_timesheet,
	}
}

const messages = Object.assign(languages);

const i18n = new Vuei18n({

	locale : defaultLocale,
	fallbackLocale : 'fr',
	messages 

})

export default i18n;